'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _mapCategories = require('./map-categories.component');

var _mapCategories2 = _interopRequireDefault(_mapCategories);

var _mapCategories3 = require('./map-categories.service');

var _mapCategories4 = _interopRequireDefault(_mapCategories3);

require('./map-categories.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.map-categories', [_angularUiRouter2.default]).component('mapCategories', _mapCategories2.default).service('MapCategoriesService', _mapCategories4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('mapCategories', {
    parent: 'admin',
    url: '/map-categories',
    component: 'mapCategories',
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/map-categories/map-categories.module.js